import { render, staticRenderFns } from "./ValuationRequestUpdateNoteModal.vue?vue&type=template&id=165725f2"
import script from "./ValuationRequestUpdateNoteModal.vue?vue&type=script&lang=js"
export * from "./ValuationRequestUpdateNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports